import React, { useState } from "react";
import Modal from "react-modal";
import { LoadableImage } from "../../ui";
import style from "./ImageModal.module.css";

export const ImageModal = ({
  img,
  alt,
  aspectRatio = "4 / 3",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={style.imageModalContainer}>
      <button
        type="button"
        className={style.imageButton}
        onClick={() => setIsOpen(true)}
        aria-label={`Open full-size image: ${alt}`}
      >
        <LoadableImage
          className={style.projectImage}
          src={img}
          alt={alt}
          width={448}
          height={375}
          aspectRatio={aspectRatio}
        />
      </button>
      <Modal
        overlayClassName={style.projectModalOverlay}
        className={style.projectModal}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel={`Full-size image: ${alt}`}
      >
        <LoadableImage
          onClick={() => setIsOpen(false)}
          className={style.projectModalImage}
          src={img}
          alt={alt}
          width={448}
          height={375}
          aspectRatio={aspectRatio}
        />
      </Modal>
    </div>
  );
};
